/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { Link } from "react-router-dom";
import { Button } from "ui/chakra/components/Button";

import { ActionButtonArea } from "./components/ActionButtonArea";
import { actionButtonStyle, skeletonButtonStyle } from "./styles";

import type { FC } from "react";

type Props = {
  eventId: string;
  hasBonusMedia: boolean;
  isLiveStreaming: boolean;
  isLoadingBonus: boolean;
  isPurchased: boolean;
  orderId: number;
  ticketId: string;
};

export const ProductActionButtons: FC<Props> = (props) => {
  const {
    eventId,
    hasBonusMedia,
    isLiveStreaming,
    isLoadingBonus,
    isPurchased,
    orderId,
    ticketId,
  } = props;

  const { t } = useI18n();

  const ticketHref = isLiveStreaming
    ? `/events/${eventId}/streaming`
    : `/account/ticket/${eventId}`;

  const ticketLabel = isLiveStreaming
    ? t("settlementHistory.ticketLabel.streaming")
    : t("settlementHistory.ticketLabel.ticket");

  const showBonusButton = isPurchased && !isLoadingBonus && hasBonusMedia;

  return (
    <ActionButtonArea>
      {isPurchased && (
        <Button
          as={Link}
          to={ticketHref}
          variant="solid"
          colorScheme="primary"
          size="sm"
          css={actionButtonStyle}
        >
          {ticketLabel}
        </Button>
      )}
      <Button
        as={Link}
        to={`/events/${eventId}`}
        variant="outline"
        colorScheme="primary"
        size="sm"
        css={actionButtonStyle}
      >
        {t("settlementHistory.eventPage")}
      </Button>
      {isLoadingBonus && <div css={skeletonButtonStyle} />}
      {showBonusButton && (
        <Button
          as={Link}
          to={`/account/settlement/history/${orderId}/items/${ticketId}/downloads?events=${eventId}`}
          variant="outline"
          colorScheme="primary"
          size="sm"
          css={actionButtonStyle}
        >
          {t("settlementHistory.digitalBonusDownload")}
        </Button>
      )}
    </ActionButtonArea>
  );
};
